import React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import {
  CssDataJacketButton,
  CssDataJacketTitleTypography,
} from "../../styles/styled";
import { renameMyDataJacket } from "../../js/queriesHandling";
import { truncateStringWithEllipsis } from "../../js/stringHandling";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  textAlign: "center",
  color: theme.palette.text.secondary,
  boxShadow: "none",
}));

const CssTypography = styled(Typography)({
  color: "white",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

const CssButton = styled(Button)({
  backgroundColor: "grey",
});

export function MydataJacketCardRenameModal({
  open,
  setOpenRename,
  myDataJacketList,
  text,
  setFlag,
  flg,
  setText,
}) {
  const handleApply = () => {
    setOpenRename(false);
    handleRename();
  };
  const handleCancel = () => {
    setOpenRename(false);
    setFlag(!flg);
  };

  async function handleRename() {
    const truncatedName = truncateStringWithEllipsis(text, 50);
    setText(truncatedName);
  }

  return (
    <>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "relative",
          }}
        >
          <Box
            style={{ color: "white" }}
            sx={{
              border: "solid 1px #666666",
              position: "relative",
              backgroundColor: "#303234",
              width: "40%",
              display: "flex",
              flexDirection: "column",
              margin: "auto",
              marginTop: "100px",
            }}
          >
            <Box style={{ height: "50px", backgroundColor: "#373737" }}>
              <Stack direction="row" spacing={2}>
                <Item>
                  <CssDataJacketTitleTypography style={{ marginLeft: "32px" }}>
                    メッセージ
                  </CssDataJacketTitleTypography>
                </Item>
              </Stack>
            </Box>
            <CssTypography
              id="child-modal-description"
              style={{ margin: "20px 20px" }}
            >
              {"タイトル名を変更しますか"}
            </CssTypography>
            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "20px",
              }}
            >
              <CssDataJacketButton
                onClick={handleApply}
                style={{ width: "100px", height: "35px" }}
              >
                はい
              </CssDataJacketButton>
              <Box sx={{ marginRight: 2 }}></Box> {/* 16px の間隔 */}
              <CssButton
                onClick={handleCancel}
                style={{
                  width: "100px",
                  color: "white",
                  height: "35px",
                  border: "2px solid white",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                いいえ
              </CssButton>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
